export const reformatAmount = (amount: string): string => {
  return amount.replace(/,/g, "");
};
